import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children"];
import { styled } from '@mui/material/styles';
var Root = styled('div')(function (_ref) {
    var theme = _ref.theme;
    return {
        borderBottom: "1px solid rgba(217, 217, 217, 1)",
        marginBottom: "10px",
        width: "100%",
        "&& .css-nz481w-MuiInputBase-input-MuiInput-input": {
            marginLeft: "15px"
        }
    };
});
export var MuiBorderBottom = function (props) {
    var children = props.children, other = _objectWithoutProperties(props, _excluded);
    return /*#__PURE__*/ React.createElement(Root, null, children);
};
